<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                   <div class="modal-content  p-2">

                        <div class="modal-body pt-3">
                          <div class="card bg-white " >
                            <div class="card-body pl-3">
                              <h6 class="card-title bold float-left">Drag a pathway from the catalog below.</h6>
                              <button type="button" class="close float-right mr-3" aria-label="Close" @click="hide()" style="margin-top: -6px !important;">
                                <span aria-hidden="true" style="font-size: 35px !important;">&times;</span>
                              </button>
                              <div class="clearfix"></div>
                              <div class="col-12 p-0 text-center manager_pathway pt-4" v-if="catalogLoading == true && catalogLists.length == 0">
                                No pathway found!
                              </div>

                              <div class="row">
                                <div class="col-12 p-0 pl-2 pr-3 ml-2 manager_pathway">
                                  <div class="subtask-wrapper-catalog" v-bind:id="'subtask-wrapper-c-' + item.id" v-for="(item, index) in catalogLists" :key="index" draggable="true" @dragstart="startDrag($event, item)">
                                    <div class="panel-title-catalog focused-section-highlight">
                                      <div class="row m-0" >
                                        <div class="col-2 p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                                          <b-link v-bind:id="'subtask-wrapper-anchor1-' + item.id"
                                            v-b-toggle="'collapse-c-'  + item.id" class="p-0"  style="font-size: 15px !important; padding-left: 10px !important;" @click="getPathwaySecondFontIcon(item.id)">
                                            <img class="mr-2 ml-4" style="" height="17px" src="@/assets/manager/tasks_icon_rep_audit_trail.png" />
                                          </b-link>
                                        </div>
                                        <div class="col-8 p-0">
                                          <b-link v-bind:id="'subtask-wrapper-anchor2-' + item.id"
                                            v-b-toggle="'collapse-c-'  + item.id" class="p-0"  style="font-size: 15px !important; padding-left: 10px !important;" @click="getPathwaySecondFontIcon(item.id)">
                                              {{ item.title }}
                                          </b-link>
                                        </div>
                                        <div class="col-2 p-0 text-right pr-4" style="margin-top: -5px !important;">
                                          <b-link v-bind:id="'subtask-wrapper-anchor3-' + item.id"
                                            v-b-toggle="'collapse-c-'  + item.id" class="p-0 angle_class_font"  style="padding-left: 10px !important;" @click="getPathwaySecondFontIcon(item.id)">
                                              <i class="fa fa-angle-right angle-class" v-bind:id="'angle-c-' + item .id" aria-hidden="true" ></i>
                                          </b-link>
                                        </div>
                                      </div>
                                      <div class="clearfix"></div>
                                    </div>
                                    <b-collapse v-bind:id="'collapse-c-' + item.id" class="subtask-step-display">
                                      <div class="col-8 p-0 float-left">
                                        <div class="subtask-step-display-item" v-if="item.steps.length > 0" v-for="(step, sindex) in item.steps" :key="sindex">
                                          <div class="row">
                                            <div class="col-12">{{ step.stepTitle }}</div>
                                            <div class="subtask-step-objective-display-item" v-if="step.objective.length > 0" v-for="(objective, oindex) in step.objective" :key="oindex">
                                              <div class="row">
                                                <div class="col-12">{{ objective.objectiveName }}</div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-4 pr-0 float-right pt-3 text-right pr-4" >
                                        <button class="btn ma-blue-btn btn-md input-height-15 pathwayBtn" @click="selectPathway(item.steps)"
                                          style="text-transform: capitalize; width: auto; padding-left: 15px !important;  padding-right: 15px !important;"    >Select Pathway</button>  
                                      </div>
                                      <div style="clear: both;"></div>
                                    </b-collapse>  
                                    <div class="clearfix"></div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 p-0 text-center pt-5" >
                                <button class="btn ma-blue-btn btn-md input-height-15 pathwayBtn mr-2" style="text-transform: initial;"
                                    @click="submitPathway" >Build your own</button>  
                              </div>


                            </div>
                          </div>
                        </div>
                        <div class="modal-footer mb-5"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            catalogLists: [],
            catalogLoading: false,
        }
    },
    components: {

    },
    methods: {    
        selectPathway(stepsObj) {
          this.$store.dispatch('catalog_pathway_steps', '');
          this.$store.dispatch('catalog_pathway_steps', stepsObj);
          this.$parent.closeCatalogListsAfterDragDrop();
        },
        submitPathway() {
          this.$store.dispatch('catalog_pathway_steps', '');
          this.$parent.closeCatalogListsOpenBuildown();
        },
        getPathwayCatalogLists() {
          axios.get('/manager/get-pathway-catalog-lists', {
            params: {
              account_id: this.$store.state.user_accountid,
            }
          })
          .then(response =>  {
            this.catalogLists = response.data.catalogLists;
            this.catalogLoading = false;
            setTimeout(() => { 
              for(var i=0; i<this.catalogLists.length; i++) {
                var id = this.catalogLists[i].id;
                var id1Tag = 'subtask-wrapper-anchor1-' + id;
                var id2Tag = 'subtask-wrapper-anchor2-' + id;
                var id3Tag = 'subtask-wrapper-anchor3-' + id;
                document.getElementById(id1Tag).removeAttribute("href");
                document.getElementById(id2Tag).removeAttribute("href");
                document.getElementById(id3Tag).removeAttribute("href");
              }
              
            }, 500);
          })
          .catch(function(error) {
            console.log(error);
          });

        },
        getPathwaySecondFontIcon(id) {
          if (document.getElementById('collapse-c-' + id).style.display == "") {
            document.getElementById('angle-c-'+ id).className = "fa fa-angle-right angle-class";
            document.getElementById('subtask-wrapper-c-'+ id).className = "subtask-wrapper-catalog";
          } else {
            document.getElementById('angle-c-'+ id).className = "fa fa-angle-down angle-class";
            document.getElementById('subtask-wrapper-c-'+ id).className = "subtask-wrapper-catalog";
          }
        },
        startDrag(event, item) {
            event.dataTransfer.setData('itemId', item.id);
            const jsonString = JSON.stringify(item.steps);
            event.dataTransfer.setData('steps', jsonString);
            event.dataTransfer.setData('itemName', item.title);
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'all';
        },   
        hide() { 
            this.$emit('close');
        },
    },
    created() {
      this.catalogLoading = true;
      this.getPathwayCatalogLists();
    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 30%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 18%;
}
.receipt-heading-1-1 {
  width: 15%;
}
.receipt-heading-6-1 {
  width: 18%;
}
.receipt-heading-2-1 {
  width: 15%;
}
.receipt-heading-3-1 {
  width: 22%; 
}
.receipt-heading-4-1 {
  width: 18%;
  text-align: right;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.catalog-border {
    border: 1px solid #E2E2E2;
    border-radius: 7px;
    min-height: 55px;
    margin-top: 10px;
    padding-top: 15px;
    color: #71706F;
    cursor: pointer;
}
.cp-heading-title {
    font-size: 12px;
    padding-left: 35px;
    padding-top: 6px;
}
.manager_pathway .subtask-wrapper-catalog {
		margin-top: 15px;
		margin-left: 30px;
		margin-right: 30px;
    padding-top: 10px;
		border: 1px solid #B2B2B2;
		border-radius: 6px;
	}
	.manager_pathway .subtask-wrapper-catalog .panel-title-catalog {
    margin-top: 8px;
    margin-bottom: 6px;
		height: 40px;
		color: #646F71 !important;
    font-size: 13px;
    font-weight: bold;
	}
  .manager_pathway .subtask-wrapper-catalog:hover, .manager_pathway .subtask-wrapper-catalog:focus {
    cursor: grab;
		border: 1px solid #E2F3F9;
		background-color: #E2F3F9;
  }
  .manager_pathway .subtask-wrapper-catalog:active {
    cursor: grabbing;
		border: 1px solid #E2F3F9;
		background-color: #E2F3F9;
  }
  .manager_pathway .subtask-wrapper-catalog:has(div div a i.fa-angle-down) {
    cursor: grab;
		border: 1px solid #E2F3F9;
		background-color: #E2F3F9;
  }
  .manager_pathway .subtask-wrapper-catalog .panel-title-catalog a:hover, .manager_pathway .subtask-wrapper-catalog .panel-title-catalog a:focus {
    cursor: grab;
  }
  .manager_pathway .subtask-wrapper-catalog .panel-title-catalog .angle-class {
    cursor: pointer;
  }
  .manager_pathway .subtask-wrapper-catalog .subtask-step-display {
    border-top: 1px solid #B2B2B2;
    border-radius: 0px;
    margin-top: -15px;
    padding-left: 40px;
    padding-bottom: 20px;
    color: #646F71 !important;
  }
  .subtask-step-display-item {
    padding-top: 10px;
    font-weight: bold;
    font-size: 15px;
  }
  .subtask-step-objective-display-item {
    padding-left: 40px;
    width: 100%;
  }
	.manager_pathway .subtask-wrapper-catalog .panel-title-catalog a, .manager_pathway .subtask-wrapper-catalog .panel-title-catalog a:hover{
		color: #646F71 !important;
    text-decoration: none;
	} 
	.angle_class_font {
		font-size: 25px !important;
		margin-top: 0px !important;
		color: #646F71 !important;
	}
  </style>




// WEBPACK FOOTER //
// src/components/enterpriseadmin/pathway_builder_cataloglists.vue